// School-specific exceptions v1 hard-codes on the booking pages, kept in
// one place.

/** Schools that asked for the check-in QR code not to be shown (v1's
 * BookingReceiptCard list). */
export const SCHOOLS_HIDE_QR_CODE: readonly string[] = ["bmDxPjPqe7QoNLk76", "3t7gZeu8pz7AiAeAM"];

/** Schools that asked for their tutors not to be shown on session lists
 * (v1's SessionDateList list; the same two schools). */
export const SCHOOLS_HIDING_TUTORS: readonly string[] = ["bmDxPjPqe7QoNLk76", "3t7gZeu8pz7AiAeAM"];
